import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  ASSIGNMENT_STATUSES,
  getStatusText,
  getStatusColor,
  getStatusTextColor,
  getStatusBorderColor
} from '../../../constants/assignmentStatuses';

const AssignmentStatus = ({ 
  selectedStatuses = [], 
  onStatusToggle,
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(ASSIGNMENT_STATUSES).map((status) => {
        const statusText = getStatusText(status);
        const isSelected = selectedStatuses.includes(status);
        
        return (
          <FilterChip
            key={status}
            label={statusText}
            isSelected={isSelected}
            onClick={() => onStatusToggle(status)}
            backgroundColor={getStatusColor(status)}
            textColor={getStatusTextColor(status)}
            borderColor={getStatusBorderColor(status)}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default AssignmentStatus; 